var common = require("./common");
var filterLogin = [
  "wechatMsg",
  "dingtalkMsg",
  "wechat-bind",
  "weixiaoMsg",
  "weixiao-bind",
  "feishu-bind",
  "wx-bind",
  "wxMsg",
  "dd-bind",
  "appError",
  "prevent",
  "secureClientMsg",
  "login",
  "tenantError",
  "kfLogin",
  "resetPassword",
  "sso", // 企业微信扫码登录时需要
];
if (typeof String.prototype.startsWith != "function") {
  String.prototype.startsWith = function (prefix) {
    return this.slice(0, prefix.length) === prefix;
  };
}

function isLoginFilter() {
  var hash = window.location.hash;
  if (hash.startsWith("#/")) hash = hash.substring(2);
  var indexOf = hash.indexOf("?");
  if (indexOf > -1) hash = hash.substring(0, indexOf);
  return filterLogin.indexOf(hash) > -1;
}

module.exports = {
  isLogin: function (router, noRedirect) {
    var $this = this;
    setTimeout(function () {
      common.fetch("/auth/isLogin", {
        success: function (data) {
          // 初始化Profile
          if (data.data) {
            $this.getUser(router, noRedirect);
          } else {
            if (isLoginFilter()) {
              return false;
            }
            if (data.redirectUrl) {
              common.redirectTo(data.redirectUrl);
            } else {
              router.redirect("#/login" + location.search);
            }
          }
        },
      });
    }, 300);
  },
  getUser: function (router, noRedirect) {
    setTimeout(function () {
      common.fetch("/auth/getUser", {
        handleError: function (data) {
          if (
            common.browserInfo().name === "MSIE" &&
            common.browserInfo().version <= 9
          ) {
            router.redirect("#/login" + location.search);
          } else {
            common.redirectTo("/#/login" + location.search);
          }
        },
        success: function (data) {
          // 初始化Profile
          common.initStorage(data.data);
          if (!noRedirect) {
            common.redirectTo("/#/appList");
          }
        },
      });
    }, 300);
  },
  ccbLogin: function (router) {
    var $this = this;
    var t = common.urlSearch(location.href)["st"];
    if (t) {
      common.fetch("/auth/ccbLogin?st=" + t, {
        handleError: function (data) {},
        success: function (data) {
          $this.getUser(router);
        },
      });
    } else {
      this.isLogin(router);
    }
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/utiles/routerUtils.js
// module id = 20
// module chunks = 0